import React from 'react';
import chat from '../assets/chat.svg';
import email from '../assets/email.svg';
import website from '../assets/website.svg';
import './Automations.css';
import ActiveAlertsContainer from './ActiveAlertsContainer';

function SupportTab(props) {
  return (
    <div>
      <div className="content">
        <h2 className="mb-075">Support</h2>
        <div className="white-wrapper support">
          <button className="primary-btn">
            <img src={chat} alt="chat" onClick={() => window.zE('messenger', 'open')} />
            Chat
          </button>
          <a
            className="primary-btn"
            rel="noopener noreferrer"
            target="_blank"
            href="mailto:support@swidget.com?subject=VacantView%20Support"
          >
            <img src={email} alt="email" />
            Email
          </a>
          <a className="primary-btn" target="_blank" rel="noopener noreferrer" href="https://vacantview-support.swidget.com/">
            <img src={website} alt="website" />
            Website
          </a>
        </div>
        {props.showAlerts
        && (
        <ActiveAlertsContainer
          setAlertLoading={props.setAlertLoading}
          setSelectedEvent={props.setSelectedEvent}
        />
        )}
      </div>
    </div>
  );
}

export default SupportTab;
